import BaseUseCase from "../../base_use_case.js.jsx";

class InvestmentPersonalInfoUseCase extends BaseUseCase {

  execute(params) {
    return this.httpClient({
      ...this.requestConfig(),
      method: "post",
      url: `/api/v1/projects/investment_steps/personal_info`,
      data: this.wrapParams(params, "investment"),
    });
  }
}

const instance = new InvestmentPersonalInfoUseCase();
export default instance;